<template>
    <SmartLinkItemComponent v-if="model" :id="model?.system?.id" :component="!model?.system?.workflow">
        <div class="media-block" :class="[backgroundStyle, backgroundColor]" :style="backgroundImage">
            <div class="container" :class="{'pt-0': paddingModifications['pt-0'], 'pb-0': paddingModifications['pb-0']}" data-aos="fade-in">

                <div v-if="firstOrDefault(model.elements.primary_image.value) || firstOrDefault(model.elements.primary_mobile_images.value)" class="primary-image">
                    <div class="desktop" >
                        <SmartLinkStandaloneElement :codename="type.elements.primary_image.codename">
                            <NuxtImg :src="model.elements.primary_image.value[0]!.url" class="img-fluid" />
                        </SmartLinkStandaloneElement>
                    </div>
                    <div class="mobile">
                        <template v-if="firstOrDefault(model.elements.primary_mobile_images.value)">
                            <SmartLinkStandaloneElement :codename="type.elements.primary_mobile_images.codename">
                                <NuxtImg v-for="(img,index) in model.elements.primary_mobile_images.value" :key="index" :src="img.url" class="img-fluid" />
                            </SmartLinkStandaloneElement>
                        </template>
                        <template v-else>
                            <SmartLinkStandaloneElement :codename="type.elements.primary_image.codename">
                                <NuxtImg :src="model.elements.primary_image.value[0]!.url" class="img-fluid" />
                            </SmartLinkStandaloneElement>
                        </template>
                    </div>
                </div>

                <div v-if="model.elements.iframe.value">
                    <SmartLinkStandaloneElement :codename="type.elements.iframe.codename">
                        <IFrame v-for="iframe in pageStore.getListAs<IframeModel>(model.elements.iframe.value)" :key="iframe.system.id" :model="iframe" />
                    </SmartLinkStandaloneElement>
                </div>

                <div v-if="!isEmpty(model.elements.video_embed.value)" class="video">
                    <SmartLinkStandaloneElement :codename="type.elements.video_embed.codename">           
                        <div v-html="model.elements.video_embed.value"></div>               
                    </SmartLinkStandaloneElement>
                </div>
            </div>

        </div>
    </SmartLinkItemComponent>
</template>

<script lang="ts" setup>
import { onMounted, onBeforeUnmount, ref } from 'vue';
import { contentTypes, type IframeModel, type MediaBlockModel } from '~~/app/models';
import SmartLinkStandaloneElement from '../smart-links/SmartLinkStandaloneElement.vue';
const type = contentTypes.media_block;
const pageStore = usePageStore();
const props = defineProps<{ model: MediaBlockModel }>();

const paddingModifications = getPaddingModifications(props.model.elements.padding_modifications__padding_modifications)

const backgroundStyle = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.image_style?.value)?.codename) {
        case 'image_background':
            return 'bg-image';                  
        default:
            return '';
    }
});

const backgroundColor = computed(() => {
    switch (firstOrDefault(props?.model?.elements?.background_color?.value)?.codename) {
        case 'white':
            return 'bg-white';
        case 'navy':
            return 'bg-navy';
        case 'pale_blue':
            return 'bg-pale-blue';    
        case 'jade':
            return 'bg-jade';                    
        default:
            return '';
    }
});

// START: Background Image, toggle between desktop and mobile image on lg breakpoint
const backgroundImage = ref({});

const updateBackgroundImage = () => {
    if (typeof window !== 'undefined') {
        const desktopUrl = props.model.elements.background_image.value[0]?.url;
        const mobileUrl = props.model.elements.mobile_background_image.value[0]?.url;
        const imageUrl = mobileUrl && window.matchMedia('(max-width: 960px)').matches ? mobileUrl : desktopUrl;
        backgroundImage.value = imageUrl ? { 'background-image': `url(${imageUrl})` } : {};
    }
};

onMounted(() => {
    updateBackgroundImage();
    window.addEventListener('resize', updateBackgroundImage);
});

onBeforeUnmount(() => {
    window.removeEventListener('resize', updateBackgroundImage);
});
// END: Background Image
</script>